import Stack from '@mui/material/Stack';
import { SelectedDependencyWithClearHistoryProps } from '../dependencies/types';
import { colors, Tag, Typography } from '@sweep-io/sweep-design';
import { Virtuoso } from 'react-virtuoso';
import pluralize from 'pluralize';
import { SingleSelectFilterPopoverOption } from '../../common/filters/single-select-filter/SingleSelectFilterPopover';
import { DialogLoader } from '../../common/dialogs/DialogLoader';
import { OPTION_ALL } from '../../common/filters/single-select-filter/utils';
import { useUniversalSearchContext } from './UniversalSearchContext';
import { useState } from 'react';
import { UniversalSearchListItem } from './UniversalSearchListItem';
import Box from '@mui/material/Box';
import { SalesforceItem } from '../../parser/ParserTypes';

interface UniversalSearchListProps {
  configurationItems: SalesforceItem[];
  onListItemClick: (props: SelectedDependencyWithClearHistoryProps) => void;
  activeItemId?: string;
  filterOptions: SingleSelectFilterPopoverOption[];
  onSelectedFilterItem: (key?: string) => void;
  selectedFilterValue?: string;
  showLoader?: boolean;
  isExpandedMode?: boolean;
  renderRightElement?: (item: SalesforceItem, isHovered: boolean) => React.ReactNode | null;
  getItemStyling?: (item: SalesforceItem) => object;
  forceRenderIcons?: boolean;
}

export const UniversalSearchList = ({
  configurationItems,
  onListItemClick,
  activeItemId,
  filterOptions,
  selectedFilterValue,
  onSelectedFilterItem,
  showLoader,
  renderRightElement,
  getItemStyling,
  forceRenderIcons,
  isExpandedMode,
}: UniversalSearchListProps) => {
  const { searchTxt } = useUniversalSearchContext();
  const [hoveredItemId, setHoveredItemId] = useState<string | null>(null);

  const itemsCount = configurationItems.length;
  const selectedFilter = filterOptions.find(
    (filterOption) => filterOption.value === selectedFilterValue,
  );

  if (!itemsCount) {
    return <></>;
  }

  return (
    <Stack height="100%">
      <DialogLoader visible={showLoader} variant="light" />

      <Stack p={2} gap={1}>
        <Box>
          {!!selectedFilter && selectedFilter.label !== OPTION_ALL.label && (
            <Tag
              size="tiny"
              color={colors.grey[120]}
              label={selectedFilter.label}
              onDelete={() => onSelectedFilterItem(undefined)}
            />
          )}
        </Box>
        <Typography color={colors.grey[700]} variant="body">
          Showing {pluralize('result', itemsCount, true)}
        </Typography>
      </Stack>

      <Virtuoso
        style={{ height: '100%', width: '100%' }}
        data={configurationItems}
        itemContent={(idx, item) => {
          return (
            <UniversalSearchListItem
              searchTxt={searchTxt}
              item={item}
              isExpandedMode={isExpandedMode ?? false}
              onListItemClick={onListItemClick}
              activeItemId={activeItemId ?? ''}
              hoveredItemId={hoveredItemId ?? ''}
              renderRightElement={renderRightElement ?? (() => null)}
              getItemStyling={getItemStyling ?? (() => ({}))}
              forceRenderIcons={forceRenderIcons ?? false}
              setHoveredItemId={setHoveredItemId}
            />
          );
        }}
      />
    </Stack>
  );
};
